module.exports = __webpack_public_path__ + "img/ejympng.66a91e9f.jpg";